module.exports = __webpack_public_path__ + "img/invalid-address.f4cc903e.png";